export const privilege = {
    group: {
        'Admin': {
            read:true,
            edit:true,
            status:{
                read: true,
                edit: true,
                full: true,
            },
            repair:{
                read: true,
                edit: true,
                full: true,
            }

        },
        'Service Desk': {
            read:true,
            edit:true,
            status:{
                read: true,
                edit: false,
                full: false,
            },
            repair:{
                read: false,
                edit: false,
                full: false,
            }
        },
        'Service Center': {
            read:false,
            edit:false,
            status:{
                read: false,
                edit: false,
                full: false,
            },
            repair:{
                read: true,
                edit: false,
                full: false,
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/privilege.js